import { ReactChild, ReactNode } from 'react';
import reactStrReplace from 'react-string-replace';
import styled, { css } from 'styled-components';

type ReplaceCallback = (
  match: string,
  index: number,
  offset: number
) => ReactChild;

const ConsentDescriptionLink = styled.a`
  ${({ theme }) =>
    theme.consents?.link &&
    css`
      &&,
      &&:hover {
        color: ${theme.consents.link.color};
        text-decoration: ${theme.consents.link.textDecoration};
      }

      &&:active {
        color: ${theme.consents.link.activeColor};
        text-decoration: ${theme.consents.link.activeTextDecoration};
      }
    `}
`;

const replaceToken = (
  text: string | ReactNode[],
  tag: string,
  replaceFn: ReplaceCallback
) => {
  const re = new RegExp(`\\[${tag}\\](.*?)\\[\\/${tag}\\]`, 'igs');

  return reactStrReplace(text, re, replaceFn) as ReactNode[];
};

const getTokenMap: (url?: string) => Record<string, ReplaceCallback> = (
  url
) => ({
  link: (content, i) => (
    <ConsentDescriptionLink
      key={content + i}
      href={url ?? '#'}
      target="_blank"
      rel="noreferrer"
    >
      <strong>{content}</strong>
    </ConsentDescriptionLink>
  ),
});

export const mapConsentDescriptionToLabel = (
  text: string,
  url?: string
): ReactNode[] => {
  const tokenMap = getTokenMap(url);

  return Object.keys(tokenMap).reduce(
    (currentText, key) => replaceToken(currentText, key, tokenMap[key]),
    [text] as ReactNode[]
  );
};
